import { inject, Injectable } from '@angular/core';

import { NgEventBus } from 'ng-event-bus';
import type { Observable } from 'rxjs';

import { FzEventBus, type MetaData } from '@fantaz/shared/domain';

@Injectable()
export class TypedNgEventBus implements FzEventBus {
  private readonly eventBus = inject(NgEventBus);

  public cast<T extends object>(binding: string, data?: T): void {
    this.eventBus.cast<T>(binding, data);
  }

  public on<T extends object>(binding: string): Observable<MetaData<T>> {
    return this.eventBus.on<T>(binding);
  }
}
